var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinglePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6305 21.2964C9.23604 21.2964 4.98371 25.8894 5.39862 31.2678L6.62939 47.2223H39.6664L40.8972 31.2678C41.3121 25.8894 37.0598 21.2964 31.6654 21.2964L28.3233 21.2964L24.6138 26.2653C23.8786 27.25 22.4058 27.2587 21.659 26.2827L17.8442 21.2964L14.6305 21.2964Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.148,
    cy: 9.259,
    r: 9.259,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5201 47.1075H44.5972C44.5972 47.1075 46.5972 33.0434 46.5972 28.8009C46.5972 24.5585 41.5319 22.2772 39.1655 21.9124C39.1655 21.9124 43.5201 25.2474 43.5201 28.8009C43.5201 35.2962 41.5201 47.1075 41.5201 47.1075Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePerson);
export default __webpack_public_path__ + "static/media/single-person.c9f0eea93ceabe76af436610ef9171e8.svg";
export { ForwardRef as ReactComponent };